import { defineComponent as _defineComponent } from 'vue'
import M from 'materialize-css/dist/js/materialize.min.js';
  import { onMounted } from 'vue';
  import PreLoader from '@/PreLoader';
  import MyHeader from '@/MyHeader';
  import TracksInput from '@/TracksInput';
  import TrackEqualizer from '@/TrackEqualizer.vue';
  import MusicPlayer from '@/MusicPlayer';
  import TrackList from '@/TrackList';
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose }) {
  expose();

  window.addEventListener('load', () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('../sw.js')
        .then(registration => {
          console.log('Service worker successfully registered', registration);
        })
        .catch(error => {
          console.log('Service worker registration failed', error);
        });
    }
  });
  
  onMounted(async () => {
    await (M || window.M).AutoInit();
  });

const __returned__ = { get PreLoader() { return PreLoader }, get MyHeader() { return MyHeader }, get TracksInput() { return TracksInput }, TrackEqualizer, get MusicPlayer() { return MusicPlayer }, get TrackList() { return TrackList } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})